import * as FeatureConfigService from '@services/FeatureConfigService'
import * as AssociateToolsRoleService from '@services/AssociateToolsRoleService'

export const StoreProgramServiceConstants = {
    VERDE: 'VERDE',
    VERDE_ROLES: Object.freeze(['associate', 'manager', 'tech-installer']),
}

/**
 * Gets the store type if there is an override.
 *
 * @return {string} - The override store type otherwise return current store type.
 */
export const getStoreTypeOverride = () => {
    if (isVerdeAssociate()) {
        return StoreProgramServiceConstants.VERDE
    }
    return null
}

/**
 * Checks if the store is a verde store.
 *
 * @return {boolean} - If store supports verde.
 */
export const isVerdeStore = () => {
    return FeatureConfigService.isFeatureEnabled(FeatureConfigService.featureConfigFeatures.VERDE_STORE_TYPE_FEATURE, false)
}

/**
 * Checks if associate has logged in with verde required scopes.
 *
 * @return {boolean} - If associate has required scopes.
 */
export const isVerdeAssociate = () => {
    return isVerdeStore() && AssociateToolsRoleService.containsAtLeastOne([...StoreProgramServiceConstants.VERDE_ROLES])
}
